import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles({
  // Main Layout Styles
  root: {
    margin: '0 auto',
    // padding: 24,
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    width: '100%',
  },
  mainContainer: {
    marginTop: 32,
  },

  // Header Styles
  header: {
    marginBottom: 32,
  },
  title: {
    fontSize: 32,
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    margin: '0 0 8px 0',
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: 16,
    color: STYLE.COLOR.TEXT2,
    margin: 0,
    fontWeight: 400,
  },

  // Grid Layout
  grid: {
    display: 'grid',
    gridTemplateColumns: '322px 322px',
    gap: 20,
    marginBottom: 32,
    width: '100%',
    justifyContent: 'center',
    '@media (max-width: 960px)': {
      gridTemplateColumns: '322px',
      gap: 16,
    },
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'minmax(0, 1fr)',
      padding: '0 0 50px',
    },
  },

  // Add Certificate Card Styles
  addCertificateCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 322,
    height: '100%',
    minHeight: 244,
    gap: 8,
    border: `1.5px dashed ${STYLE.COLOR.STROKE_DEFAULT}`,
    borderRadius: 12,
    background: '#E4E7E933',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    padding: 24,
    textAlign: 'center',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    opacity: 1,
    '&:hover': {
      borderColor: STYLE.COLOR.TEXT3,
      background: '#f5f5f5',
    },
    '&:focus': {
      outline: 'none',
      borderColor: STYLE.COLOR.ACCENT_PRIMARY,
      boxShadow: `0 0 0 3px ${STYLE.COLOR.ACCENT_PRIMARY_DISABLED}`,
    },
    '@media (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  addCertificateIcon: {
    marginBottom: 16,
    opacity: 0.6,
  },
  addCertificateText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '14px',
    color: STYLE.COLOR.TEXT3,
  },

  // Certificate Card Styles
  certificateCard: {
    position: 'relative',
    background: STYLE.COLOR.WHITE,
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: 12,
    padding: 16,
    width: 322,
    minHeight: 244,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    boxShadow: `0px 16px 20px -8px ${STYLE.COLOR.BOX_SHADOW}`,
    '@media (max-width: 600px)': {
      width: '100%',
      minHeight: 200,
    },
  },

  // Certificate Header Styles
  certificateHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 16,
    width: '100%',
    '@media (max-width: 600px)': {
      marginBottom: 12,
    },
  },
  certificateHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    minWidth: 0,
    '@media (max-width: 600px)': {
      gap: 6,
    },
  },
  certificateAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    background: '#FEF3B3', // Keep static - not available in STYLE constants
    borderRadius: '50%',
    fontSize: 18,
    fontWeight: 600,
    color: STYLE.COLOR.TEXT4,
    fontFamily: 'Poppins',
    marginRight: 2,
    flexShrink: 0,
    '@media (max-width: 600px)': {
      width: 36,
      height: 36,
      fontSize: 16,
    },
  },
  certificateInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  certificateTitle: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '21px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: 16,
    '@media (max-width: 600px)': {
      fontSize: 13,
      lineHeight: '18px',
      marginRight: 8,
    },
  },
  certificateDate: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '@media (max-width: 600px)': {
      fontSize: 11,
      lineHeight: '16px',
    },
  },
  menuButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    flexShrink: 0,
    width: 24,
    height: 24,
    '&:hover': {
      background: '#f5f5f5',
    },
  },

  // Certificate Details Styles
  certificateDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 600px)': {
      gap: 8,
    },
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 12,
    '@media (max-width: 600px)': {
      marginBottom: 8,
    },
  },
  detailLabel: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    marginBottom: 4,
    '@media (max-width: 600px)': {
      fontSize: 11,
      lineHeight: '16px',
      marginBottom: 2,
    },
  },
  detailValue: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word',
    '@media (max-width: 600px)': {
      fontSize: 13,
      lineHeight: '18px',
    },
  },
  detailValueClamped: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical' as const,
    WebkitLineClamp: 2,
    wordBreak: 'break-word',
  },

  // Certificate Dates Styles
  certificateDates: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
    marginTop: 0,
    marginBottom: 0,
    '@media (max-width: 600px)': {
      gap: 16,
    },
  },
  dateItem: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },

  // Actions Menu Styles
  actionsMenu: {
    position: 'fixed',
    background: STYLE.COLOR.WHITE,
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: 12,
    boxShadow: '0px 4px 20px rgba(0, 58, 87, 0.05)', // Keep static - specific design requirement
    zIndex: 1000,
    minWidth: 102,
    overflow: 'hidden',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 20px',
    background: 'none',
    border: 'none',
    borderBottom: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    textAlign: 'left',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: '#f5f5f5',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },

  // Responsive Styles
  rootMobile: {
    '@media (max-width: 768px)': {
      padding: 16,
    },
  },
  gridMobile: {
    '@media (max-width: 768px)': {
      gridTemplateColumns: 'minmax(0, 1fr)',
      gap: 16,
      marginBottom: 24,
      justifyContent: 'stretch',
    },
  },
  certificateDatesMobile: {
    '@media (max-width: 768px)': {
      gap: 12,
    },
    '@media (max-width: 600px)': {
      gap: 8,
    },
  },
  titleSmall: {
    '@media (max-width: 480px)': {
      fontSize: 28,
    },
  },
  certificateCardSmall: {
    // Styles now handled in certificateCard directly
  },
  addCertificateCardSmall: {
    '@media (max-width: 600px)': {
      width: '100%',
      height: 'auto',
      minHeight: 180,
      padding: 16,
    },
  },
});

export const useStylesCertificationWarningModal = makeStyles({
  modal: {
    '& .MuiDialog-paper': {
      minWidth: 800,
      maxWidth: 900,
      borderRadius: 12,
      margin: 16,
      '@media (max-width: 960px)': {
        minWidth: 'auto',
        maxWidth: '90vw',
        width: '90vw',
      },
      '@media (max-width: 600px)': {
        minWidth: 'auto',
        maxWidth: '95vw',
        width: '95vw',
        margin: 8,
        borderRadius: 8,
      },
    },
  },
  content: {
    padding: '0 4px',
    '@media (max-width: 600px)': {
      padding: '0 2px',
    },
  },
  section: {
    marginBottom: 24,
    '@media (max-width: 600px)': {
      marginBottom: 16,
    },
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    margin: '0 0 12px 0',
    lineHeight: '22px',
    wordBreak: 'break-word',
    '@media (max-width: 600px)': {
      fontSize: 14,
      lineHeight: '20px',
      margin: '0 0 8px 0',
    },
  },
  mainText: {
    fontSize: 14,
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
    margin: '0 0 12px 0',
    lineHeight: 1.5,
    '@media (max-width: 600px)': {
      fontSize: 13,
      margin: '0 0 8px 0',
    },
  },
  boldText: {
    fontWeight: 600,
  },
  certificationList: {
    margin: '0 0 0 20px',
    padding: 0,
    '@media (max-width: 600px)': {
      margin: '0 0 0 16px',
    },
  },
  listItem: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    color: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER,
    marginBottom: 4,
    wordBreak: 'break-word',
    '@media (max-width: 600px)': {
      fontSize: 14,
      lineHeight: '20px',
      marginBottom: 2,
    },
  },
  warningText: {
    fontSize: 16,
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    margin: '24px 0 0 0',
    lineHeight: '24px',
    wordBreak: 'break-word',
    '@media (max-width: 600px)': {
      fontSize: 14,
      lineHeight: '20px',
      margin: '16px 0 0 0',
    },
  },
  cancelButton: {
    minWidth: '148px !important',
  },
  cancelButtonViewMore: {
    minWidth: '148px !important',
  },
  proceedButton: {
    minWidth: '214px !important',
  },
  addCertificationButton: {
    minWidth: '204px !important',
  },
});

export const useStylesCertificationWarningBanner = makeStyles({
  bannerWrapper: {
    marginBottom: 40,
    marginTop: 16,
  },
  banner: {
    backgroundColor: STYLE.COLOR.WARNING_NOTE,
    borderRadius: 4,
    padding: '8px 12px',
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: 'fit-content',
  },
  warningIcon: {
    width: 18,
    height: 16,
    flexShrink: 0,
    marginRight: 4,
  },
  bannerText: {
    fontSize: 14,
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
    lineHeight: '20px',
    marginLeft: 4,
  },
  viewMoreLink: {
    fontSize: 14,
    fontWeight: 400,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
    textDecoration: 'underline',
    marginLeft: 8,
    whiteSpace: 'nowrap',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: STYLE.COLOR.ACCENT_PRIMARY_DARKER,
    },
  },
});

export const useStylesAddCertificationModal = makeStyles({
  modal: {
    '& .MuiDialog-paper': {
      width: '1064px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      borderRadius: 12,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      '@media (max-width: 600px)': {
        maxWidth: 'calc(100vw - 32px) !important',
        maxHeight: 'calc(100vh - 64px) !important',
        margin: '32px 16px !important',
      },
    },
  },
  modalContent: {
    padding: '24px !important',
    overflow: 'auto !important',
    maxHeight: 'calc(90vh - 200px)',
    flexShrink: 1,
    '@media (max-width: 600px)': {
      maxHeight: 'calc(100vh - 64px - 180px)',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: 16,
    },
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  addImageSection: {
    marginBottom: 34,
  },
  addImageContainer: {
    marginTop: 0,
  },
  addImageTextContainer: {
    marginTop: 14,
  },
  charCount: {
    fontSize: 12,
    fontFamily: 'Poppins',
    color: STYLE.COLOR.TEXT2,
    textAlign: 'right',
    marginTop: 4,
    display: 'block',
  },
  cancelButton: {
    minWidth: '148px !important',
  },
  saveButton: {
    minWidth: '132px !important',
  },
});

export const useStylesDeleteCertificationModal = makeStyles((theme: any) => ({
  modal: {
    '& .MuiDialog-paper': {
      width: '560px',
      maxWidth: '100%',
    },
  },
  modalTitle: {
    justifyContent: 'flex-end',
    paddingBottom: '0px !important',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: '0px',
    paddingTop: '0px !important',
    paddingBottom: '16px !important',
    marginTop: -12,
  },
  modalActions: {
    borderWidth: '0px',
    justifyContent: 'center !important',
    paddingBottom: '32px !important',
  },
  imageParent: {
    height: 90,
    width: 90,
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px',
    color: STYLE.COLOR.TEXT1,
    textAlign: 'center',
    marginTop: 32,
    marginBottom: 12,
  },
  warningText: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '26px',
    color: STYLE.COLOR.TEXT1,
  },
  certificationName: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },
  button: {
    minWidth: '140px !important',
  },
}));
